import React, { useCallback, useState } from "react";
import { Link, useNavigate as reactUseNavigate, useLocation } from "react-router-dom";
import { NavigationMenu } from "@shopify/app-bridge-react";
import { Navigation } from "@shopify/polaris";
import { HomeMinor, OrdersMinor, ProductsMinor } from "@shopify/polaris-icons";
import { getNavigationLinks } from "@/Assets/Mocks/Navigation.mock";
import { localStorage } from "@/Utils/Index";

export const AppNavigationMenu = () => {
  const NavigationLinks = getNavigationLinks();
  if (process.env.ENV === "dev") {
    NavigationLinks.splice(2, 0, {
      label: "Backend Testing",
      destination: "/backendTesting",
    });
  }
  const handleActiveLink = (link, location) => {
    const params = new URLSearchParams(location.href);
    const activenavmenu = params.get("activenavmenu");
    let parentMenu = "";
    if (activenavmenu?.length > 0) {
      parentMenu = `/${activenavmenu}`;
      return link.destination === parentMenu;
    } else {
      return link.destination === location.pathname;
    }
  };

  const location = useLocation();
  const navigation = reactUseNavigate();
  const [selected, setSelected] = useState(location.pathname);

  const handleClick = useCallback((item) => {
    navigation(item.destination);
    setSelected(item.destination);
  }, []);

  if (!localStorage()?.getItem("adminAccessToken")) {
    return (
      <NavigationMenu
        navigationLinks={NavigationLinks}
        matcher={(link, location) => handleActiveLink(link, location)}
      />
    );
  }

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section
        items={NavigationLinks.map((item) => ({
          ...item,
          onClick: () => handleClick(item),
          icon: HomeMinor,
          selected: selected === item.destination,
        }))}
      />
    </Navigation>
  );
};

export const navigate = () => {
  let navigate;
  if (!localStorage()?.getItem("adminAccessToken")) {
    // navigate = shopifyUseNavigate();
  } else {
    navigate = reactUseNavigate();
  }
  return navigate;
};
